const styles = (theme) => ({
  kpiTopHeader: {
    fontWeight: "500",
    fontSize: "20px",
    lineHeight: "27px",
    display: "flex",
    justifyContent: "center",
    color: theme.gridTextColor,
  },
  kpiTopSubHeader: {
    fontWeight: "500",
    marginTop: "5px",
    fontSize: "14px",
    lineHeight: "20px",
    display: "flex",
    justifyContent: "center",
    color: theme.gridTextColor,
  },
  kpiBox: {
    marginTop: "25px",
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: "2px",
    padding: "2% 0%",
  },
  logBox: {
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: "2px",
    padding: "10px",
    overflowY: "auto",
    maxHeight: "350px",
  },
  logHeader: {
    marginTop: "25px",
    border: `solid ${theme.AppBGColor}`,
    borderRadius: "2px",
    padding: "10px",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "19px",
    color: theme.HeaderSelectedText,
    borderWidth: "1px 1px 0px 1px",
  },
  kpiBoxHeader: {
    fontWeight: "600",
    fontSize: "16px",
    color: theme.gridTextColor,
    lineHeight: "20px",
    paddingLeft: "4px",
  },
  kpiBoxLabel: {
    fontWeight: "500",
    fontSize: "14px",
    color: theme.gridTextColor,
    lineHeight: "20px",
  },
  kpiValueBox: {
    display: "grid",
    alignItems: "center",
    justifyContent: "center",
  },

  showLog: {
    fontWeight: "normal",
    fontSize: theme.textFontSize,
    lineHeight: "25px",
    alignItems: "center",
    display: "flex",
    color: theme.gridTextColor,
    width: "inherit",
  },
  doneIcon: {
    marginLeft: "5px",
    width: "16px",
    height: "16px",
    lineHeight: "25px",
    marginRight: "5px",
    color: theme.HeaderSelectedText,
  },
  topMargin: {
    marginTop: "25px",
  },
});

export default styles;
